import React, { useState, useEffect, useContext } from 'react'
import { navigate } from 'gatsby'

import logo from '../../../assets/images/logoActividad.png'

import  './modalPregame.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const ModalPregame = props => {
  const { handleStartGame } = props

  return (
    <div className='f-preGame-container'>
      <div className='f-preGame-container__wrapper'>
        <div className='f-preGame-container__content'>
          <h2 className='f-preGame-container__content-title'>¡Así es nuestro cuerpo!</h2>
          <div className='f-preGame-container__content-info'>
            <div className='f-preGame-container__content-info-img'>
              <p>Bienvenida a</p>
              <figure>
                <img src={logo} alt='desafio nosotras 2022'/>
              </figure>
            </div>
              <div className='f-preGame-container__content-info-txt'>

              <h3>¿Estás lista para retarte?</h3>
              <p>Demostrá que sos una experta en nuestro Mundo Nosotras</p>
              <button onClick={() => {
                pushEventDataLayer('Personajes :: Juego', 'Iniciar', 'ESTOY LISTA')
                handleStartGame()
              }}>ESTOY LISTA</button>
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default ModalPregame
